import { PhoneNumber } from '@dreryk/phone-number-common-api';

import { commonTranslationKeys, FieldControllerProps } from '@dreryk/react-common';
import { ClassNameProp, PhoneNumberInput as PhoneNumberInputComponent } from '@dreryk/react-components';

type PhoneNumberInputProps = FieldControllerProps<'phoneNumber', PhoneNumber | null> & ClassNameProp;

export const PhoneNumberInput = (props: PhoneNumberInputProps): JSX.Element => {
   const controller = props.register(props.name, {
      required: props.required,
   });

   return (
      <PhoneNumberInputComponent
         testId={props.name}
         label={commonTranslationKeys.phone}
         controller={controller}
         className={props.className}
      />
   );
};
